<ng-container *ngIf="breadcrumbView !== 'false'">
    <div *ngIf="breadcrumbView !== 'simple' && !('mobile' | mediaQuery)" class="tt-app-breadcrumbs--tabs">
        <tt-tabs class="tt-app__breadcrumbs tt-scrollbar" [(ttSelectedId)]="selectedState" ttDismissable ttAutoSelectFirst="false">
            <tt-tab
                *ngFor="let pin of pinnedStates; index as i"
                class="tt-app__breadcrumb tt-app__breadcrumb--pinned"
                [ttId]="'' + pin.webpagepinned_keyno"
                [ttLabel]="pin.pinned_name"
                ttTranslateLabel="false"
                (ttClick)="onPinnedStateClick($event, pin)"
                (ttDismiss)="unPin({ pin: pin, index: i })"
            ></tt-tab>
        </tt-tabs>
        <tt-tabs class="tt-app__breadcrumbs tt-scrollbar" [(ttSelectedId)]="selectedState" ttDismissable ttAutoSelectFirst="false">
            <tt-tab
                *ngFor="let crumb of breadCrumbs; index as i"
                class="tt-app__breadcrumb"
                [ttId]="crumb.id"
                [ttLabel]="crumb.title"
                ttTranslateLabel="false"
                (ttClick)="onStateChainItemClick($event, crumb)"
                (ttDismiss)="removeStateChainItem({ stateChainItem: crumb, index: i })"
                [ttDismissable]="crumb.name !== 'mainmenu' && crumb.date !== selectedState"
            >
                <button
                    *ngIf="crumb.name !== 'mainmenu'"
                    class="tt-app-breadcrumb__pin-button"
                    (click)="$event.stopImmediatePropagation(); $event.stopPropagation(); $event.preventDefault(); pin({ stateChainItem: crumb, index: i })"
                >
                    <span class="fal fa-thumbtack"></span>
                </button>
            </tt-tab>
        </tt-tabs>
    </div>
    <tt-breadcrumbs *ngIf="breadcrumbView === 'simple' || ('mobile' | mediaQuery)">
        <tt-breadcrumb-item *ngFor="let stateItem of state.stateChain$ | async; index as i" (ttClick)="onStateChainItemClick($event, stateItem)">{{ stateItem.title }}</tt-breadcrumb-item>
    </tt-breadcrumbs>
</ng-container>
